import { useSessionContext } from 'contexts/sessionProvider/SessionProvider';
import {
  SUBSCRIPTION_TYPE,
  ARL_PRODUCT_IDS,
  AU_PARTNER_PRODUCT_IDS,
  NZ_PARTNER_PRODUCT_IDS,
  PAYROLL_ONLY_PRODUCT_IDS,
  AI_BAS_ADD_ON_IDS
} from '../../constants';
import { ConfirmationContentType } from './types';
import config from '../../Config';

const JB_HI_FI_PROMO_CODES = [
  'JBHIFI-12M-LITE',
  'JBHIFI-12M-PRO',
  'JBHIFI-12M-PAYROLL-ONLY'
];

export const useConfirmationContent = (): ConfirmationContentType => {
  const {
    promoCode, subscriptionType, productId, addonIds
  } = useSessionContext();
  return ({
    title: 'You\'re all set!',
    header: 'Now you can track finances, simplify taxes, and send invoices - all in one place.',
    body: undefined,
    footer: undefined,
    button: {
      startText: 'Setting up your software',
      endText: 'Open MYOB',
      link: config.PRODUCT_URL,
      duration: config.DEFAULT_BUTTON_DISABLE_TIME
    },
    ...(addonIds?.some(id => AI_BAS_ADD_ON_IDS.includes(id)) && {
      header: 'Now you can track finances, simplify taxes, send invoices and manage BAS – all in one place.'
    }),
    ...(promoCode && JB_HI_FI_PROMO_CODES.includes(promoCode) && {
      header: 'You will receive a confirmation email with your MYOB Serial Number shortly.',
      body: undefined,
      footer: 'Your subscription auto-renews until it is cancelled. ' +
        'You can cancel within the \'Manage My Product\' section of \'My Account\'.'
    }),
    ...(ARL_PRODUCT_IDS.includes(productId) && {
      title: 'Almost there...',
      header: 'Check your email for instructions on how to create your account and download AccountRight.',
      body: undefined,
      button: {
        text: 'Download now',
        link: 'https://download.myob.com/arl/Current/MYOB_AccountRight.exe'
      }
    }),
    ...(PAYROLL_ONLY_PRODUCT_IDS.includes(productId) && {
      title: 'You\'re all set!',
      header: 'Keep pay runs accurate and compliant with ease.',
      body: undefined,
      footer: undefined
    }),
    ...(subscriptionType === SUBSCRIPTION_TYPE.NEW_TRIAL && {
      title: 'What happens next?'
    }),
    ...((AU_PARTNER_PRODUCT_IDS.includes(productId) || NZ_PARTNER_PRODUCT_IDS.includes(productId)) && {
      button: {
        startText: 'Go to MYOB Practice',
        endText: 'Go to MYOB Practice',
        link: config.PARTNER_PROGRAM_PRODUCT_URL,
        duration: config.PARTNER_BUTTON_DISABLE_TIME
      },
      title: 'Thank you!',
      header: undefined,
      body: undefined,
      footer: undefined,
      nextSteps: {
        numbered: true,
        items: [{
          title: 'We\'re setting up your MYOB Practice software.',
          text: 'It\'ll take about 2 minutes. When it\'s ready, you\'ll be able to create ' +
              'and manage client files straight away.'
        },
        {
          title: 'Access MYOB Business Pro',
          text: 'You\'ll receive an email shortly to set up your business. ' +
              'This email will also have a link to your MYOB Practice.'
        }
        ]
      }
    })
  });
};
